// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "/dashboard";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "/login"),
  register: path(ROOTS_AUTH, "/register"),
  loginUnprotected: path(ROOTS_AUTH, "/login-unprotected"),
  registerUnprotected: path(ROOTS_AUTH, "/register-unprotected"),
  verify: path(ROOTS_AUTH, "/verify"),
  resetPassword: path(ROOTS_AUTH, "/reset-password"),
};

export const PATH_PAGE = {
  comingSoon: "/coming-soon",
  maintenance: "/maintenance",
  pricing: "/pricing",
  payment: "/payment",
  about: "/about-us",
  contact: "/contact-us",
  faqs: "/faqs",
  page404: "/404",
  page500: "/500",
  components: "/components",
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, "/master"),
    inquiryList: path(ROOTS_DASHBOARD, "/inquiry-list"),
  },

  master: {
    root: path(ROOTS_DASHBOARD, "/master"),
    homeSlider: path(ROOTS_DASHBOARD, "/master/homeSlider"),
    ourNetwork: path(ROOTS_DASHBOARD, "/master/ourNetwork"),
    service: path(ROOTS_DASHBOARD, "/master/service"),
    product: path(ROOTS_DASHBOARD, "/master/product"),
    promoCode: path(ROOTS_DASHBOARD, "/master/promoCode"),
    variations: path(ROOTS_DASHBOARD, "/master/variations"),
    swimLane: path(ROOTS_DASHBOARD, "/master/swimLane"),
    pincode: path(ROOTS_DASHBOARD, "/master/pincode"),
  },
};
